import { Component, OnInit, OnDestroy, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import {
  map,
  takeUntil,
  first,
  startWith,
  distinctUntilChanged,
} from 'rxjs/operators';
import { AlgOtpModalComponent } from '../../components/dialogs/alg-otp-modal/alg-otp-modal.component';
import 'moment/locale/it';
import { ModalDialogService } from 'ngx-modal-dialog';
import { UtilsService } from '../../services/utils.service';
import { AlgConditionModalComponent } from '../../components/dialogs/alg-condition-modal/alg-condition-modal.component';

import { environment } from '../../../environments/environment';
import {
  AlgConsensoService,
  REQUEST_STATUS_INVALID,
  REQUEST_STATUS_OK,
} from '../../services/alg-consenso.service';
import {
  ApprovalFeedback,
  ApprovalLinearRequest,
} from '../../services/alg-consenso.service.d';
import { LocationStrategy } from '@angular/common';
import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
@Component({
  selector: 'alg-linear-consent-request',
  templateUrl: './alg-linear-consent-request.html',
  styleUrls: ['./alg-linear-consent-request.scss'],
})
export class AlgLinearConsentRequestComponent implements OnInit, OnDestroy {
  public isLoading$: Observable<boolean>;
  public productType$: Observable<string>;
  public operatorRating$: Observable<ApprovalFeedback>;
  public isConsentsOk: boolean;
  public feedbackOptions = [
    { image: 'bad', value: 100 },
    { image: 'normal', value: 200 },
    { image: 'good', value: 300 },
    { image: 'excellent', value: 400 },
  ];
  public feedbackModalContent = {
    title: 'La tua privacy per noi è importante.',
    description: '',
  };
  public product: any;
  public isLight: boolean;
  public isGas: boolean;
  public overDropFront: boolean;
  public overDropBack: boolean;
  public uploaderFront: FileUploader;
  public uploaderBack: FileUploader;
  public uploadedDocumentFront: boolean;
  public uploadedDocumentBack: boolean;
  public documentUploadedFront: string;
  public documentUploadedBack: string;
  public fileFormatErrorFront: boolean;
  public fileFormatErrorBack: boolean;

  public optionGasValue = false;
  public optionLightValue = false;
  public goNextStep: boolean;

  // KEYSTONE VALUE INFORMATIVE THAT HAS BEEN READED
  public informativeGasBeenReaded = false;
  public informativeLightBeenReaded = false;

  public isLinearGasOn: boolean;
  public isLinearLightOn: boolean;

  public idRichiesta: string;
  public typeRichiesta: string;
  public codeRichiesta: string;
  public temporaryUrl: string;
  public consentsWithAdditionalProperty: ApprovalLinearRequest;
  public isOtpChecked: boolean;

  private opportunityId$: Observable<any>;
  private phone_number = '';
  private ngUnsubscribe = new Subject<void>();

  // OBSERVABLE TO WATCH REQUEST STATUS
  public isRequestOk$: Observable<boolean>;
  public isErrorGeneric$: Observable<boolean>;

  public checkboxGasContainer = {
    checkboxGasDeclare: false,
    checkboxGasInformative: false,
  };

  public checkboxLightContainer = {
    checkboxLightDeclare: false,
    checkboxLightInformative: false,
  };

  public controlGasDeclare: boolean;
  public controlGasInformative: boolean;
  public controlLightDeclare: boolean;
  public controlLightInformative: boolean;

  private _id: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private consensoService: AlgConsensoService,
    private utils: UtilsService,
    private modalDialogService: ModalDialogService,
    private viewContainer: ViewContainerRef,
    public locations: LocationStrategy
  ) {
    this.opportunityId$ = this.activatedRoute.params.pipe(
      map((params) => params && params.id)
    );
    this.isLoading$ = this.consensoService.isLoading$;

    this.productType$ = this.consensoService.approvalProduct$.pipe(
      map((product) => !!product && product.type)
    );
    this.operatorRating$ = this.consensoService.operatorRatingCode$.pipe(
      first((rating) => !!rating)
    );
    this.consensoService.gasLinearSubject$.subscribe((item) => {
      this.controlGasDeclare = !item;
    });
    this.consensoService.gasLinearInformative$.subscribe((item) => {
      this.controlGasInformative = !item;
    });
    this.consensoService.lightLinearSubject$.subscribe((item) => {
      this.controlLightDeclare = !item;
    });
    this.consensoService.lightLinearInformative$.subscribe((item) => {
      this.controlLightInformative = !item;
    });
  }

  public ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.temporaryUrl = window.location.href;
      this.idRichiesta = params.id;
      this.codeRichiesta = params.codice;
      this.typeRichiesta = this.temporaryUrl.includes('Luce&Gas')
        ? 'Luce&Gas'
        : params.tipo;
    });

    this.consensoService.fetchLinearRequest(
      this.idRichiesta,
      this.codeRichiesta,
      this.typeRichiesta
    );

    this.isRequestOk$ = this.consensoService.linearRequestStatus$.pipe(
      map((request) => request === REQUEST_STATUS_OK),
      startWith(false),
      distinctUntilChanged()
    );

    this.isErrorGeneric$ = this.consensoService.linearRequestStatus$.pipe(
      map((request) => request === REQUEST_STATUS_INVALID),
      startWith(false),
      distinctUntilChanged()
    );

    this.consensoService.linearRequest$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((request) => {
        this.isOtpChecked = request.Alg_OTPCheck__c;
        this._id = request._id;
        this.phone_number = request.Alg_LinearPhone__c;
        const URL = `${environment.api.basePath}/upload-linear-documents/request/${this._id}`;

        this.uploaderFront = new FileUploader({
          url: URL,
          autoUpload: true,
          disableMultipart: false,
          itemAlias: 'linearDocumentFront',
        });
        this.uploaderFront.onBeforeUploadItem = (item) => {
          item.withCredentials = false;
        };

        this.uploaderBack = new FileUploader({
          url: URL,
          disableMultipart: false,
          autoUpload: true,
          itemAlias: 'linearDocumentBack',
        });
        this.uploaderBack.onBeforeUploadItem = (item) => {
          item.withCredentials = false;
        };
      });

    if (this.typeRichiesta.toLowerCase() === 'gas') {
      this.isLinearGasOn = true;
    }
    if (this.typeRichiesta.toLowerCase() === 'luce') {
      this.isLinearLightOn = true;
    }
    if (this.typeRichiesta.toLowerCase() === 'luce&gas') {
      this.isLinearLightOn = true;
      this.isLinearGasOn = true;
    }
  }

  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public openModal(modalContent) {
    this.utils.disableOverflow();
    this.modalDialogService.openDialog(this.viewContainer, {
      title: modalContent.title,
      childComponent: AlgConditionModalComponent,
      settings: {
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: ' modal-title modal-title-underline',
      },
      data: {
        description: modalContent.description,
      },
    });
  }

  public readCondition(type) {
    let modalContent;
    if (type === 'dataConsent') {
      modalContent = this.feedbackModalContent;
    }
    this.openModal(modalContent || {});
  }

  // feedback
  public onFeebackModal(event) {
    if (event === 'open') {
      this.readCondition('dataConsent');
    }
  }

  public openOTPmodal() {
    if (!this.goNextStep) {
      if (!this.optionLightValue) {
        if (this.controlLightDeclare) {
          this.checkboxLightContainer.checkboxLightDeclare = true;
          if (
            this.typeRichiesta.toLowerCase() === 'luce' ||
            this.typeRichiesta.toLowerCase() === 'luce&gas'
          ) {
            this.scrollOnInvalidElement('lightInvalid');
          }
        }
        if (this.controlLightInformative) {
          this.checkboxLightContainer.checkboxLightInformative = true;
          if (
            this.typeRichiesta.toLowerCase() === 'luce' ||
            this.typeRichiesta.toLowerCase() === 'luce&gas'
          ) {
            this.scrollOnInvalidElement('lightInvalid');
          }
        }
      }
      if (!this.optionGasValue) {
        if (this.controlGasDeclare) {
          this.checkboxGasContainer.checkboxGasDeclare = true;
          if (
            this.typeRichiesta.toLowerCase() === 'gas' ||
            this.typeRichiesta.toLowerCase() === 'luce&gas'
          ) {
            this.scrollOnInvalidElement('gasInvalid');
          }
        }
        if (this.controlGasInformative) {
          this.checkboxGasContainer.checkboxGasInformative = true;
          if (
            this.typeRichiesta.toLowerCase() === 'gas' ||
            this.typeRichiesta.toLowerCase() === 'luce&gas'
          ) {
            this.scrollOnInvalidElement('gasInvalid');
          }
        }
      }

      return;
    }
    this.utils.disableOverflow();
    if (this.goNextStep) {
      if (this.optionGasValue && this.typeRichiesta === 'Gas') {
        this.consentsWithAdditionalProperty = {
          Alg_GASShowPolicy__c: true,
          Alg_LIGHTShowPolicy__c: false,
          informativeSetShowGas: true,
          informativeSetShowLight: false,
          requestId: `${this.idRichiesta}`,
          requestCode: `${this.codeRichiesta}`,
          requestType: `${this.typeRichiesta}`,
          Alg_OTPCheck__c: false,
          Alg_OTPCheckDate__c: '',
          Alg_OTPPhone__c: '',
        };
        this.isConsentsOk = true;
      }
      if (this.optionLightValue && this.typeRichiesta === 'Luce') {
        this.consentsWithAdditionalProperty = {
          Alg_GASShowPolicy__c: false,
          Alg_LIGHTShowPolicy__c: true,
          informativeSetShowLight: true,
          informativeSetShowGas: false,
          requestId: `${this.idRichiesta}`,
          requestCode: `${this.codeRichiesta}`,
          requestType: `${this.typeRichiesta}`,
          Alg_OTPCheck__c: false,
          Alg_OTPCheckDate__c: '',
          Alg_OTPPhone__c: '',
        };
        this.isConsentsOk = true;
      }
      if (
        this.optionLightValue &&
        this.optionGasValue &&
        this.typeRichiesta === 'Luce&Gas'
      ) {
        this.consentsWithAdditionalProperty = {
          Alg_LIGHTShowPolicy__c: true,
          Alg_GASShowPolicy__c: true,
          informativeSetShowLight: true,
          informativeSetShowGas: true,
          requestId: `${this.idRichiesta}`,
          requestCode: `${this.codeRichiesta}`,
          requestType: `${this.typeRichiesta}`,
          Alg_OTPCheck__c: false,
          Alg_OTPCheckDate__c: '',
          Alg_OTPPhone__c: '',
        };
        this.isConsentsOk = true;
      }
      this.modalDialogService.openDialog(this.viewContainer, {
        title: 'Un ultimo passo: verifica il tuo numero di cellulare',
        childComponent: AlgOtpModalComponent,
        settings: {
          closeButtonClass: 'close theme-icon-close',
          headerTitleClass: 'modal-title modal-title-underline textCenter',
        },
        data: {
          isConsentsOk: this.isConsentsOk,
          consents: this.consentsWithAdditionalProperty,
          phone: this.phone_number,
          linear: true,
          consensoType: 'request',
        },
      });
    }
  }

  uploadDocument(type) {
    switch (type) {
      case 'front':
        (<HTMLInputElement>document.getElementById('frontDocument')).click();
        break;

      case 'back':
        (<HTMLInputElement>document.getElementById('backDocument')).click();
        break;
    }
  }

  droppedFile(event, type) {
    switch (type) {
      case 'front':
        this.documentUploadedFront = event[0].name;
        if (
          event[0].type === 'image/png' ||
          event[0].type === 'image/jpeg' ||
          event[0].type === 'image/jpg' ||
          event[0].type === 'application/pdf'
        ) {
          this.uploadedDocumentFront = true;
          this.fileFormatErrorFront = false;
        } else {
          this.fileFormatErrorFront = true;
        }
        break;

      case 'back':
        this.documentUploadedBack = event[0].name;
        if (
          event[0].type === 'image/png' ||
          event[0].type === 'image/jpeg' ||
          event[0].type === 'image/jpg' ||
          event[0].type === 'application/pdf'
        ) {
          this.uploadedDocumentBack = true;
          this.fileFormatErrorBack = false;
        } else {
          this.fileFormatErrorBack = true;
        }
        break;
    }
    this.goToNextStep();
  }

  selectedFile(event, type) {
    switch (type) {
      case 'front':
        this.documentUploadedFront = event[0].name;
        if (event.length > 0) {
          this.uploadedDocumentFront = true;
        }
        break;

      case 'back':
        this.documentUploadedBack = event[0].name;
        if (event.length > 0) {
          this.uploadedDocumentBack = true;
        }
        break;
    }
    this.goToNextStep();
  }

  getOptionChoices(event, type) {
    switch (type) {
      case 'gas':
        this.optionGasValue = event;
        break;

      case 'light':
        this.optionLightValue = event;
        break;
    }
    this.goToNextStep();
  }

  goToNextStep() {
    if (this.typeRichiesta === 'Luce') {
      if (
        this.optionLightValue &&
        this.uploadedDocumentFront &&
        this.uploadedDocumentBack
      ) {
        this.goNextStep = true;
      } else {
        this.goNextStep = false;
      }
    }
    if (this.typeRichiesta === 'Gas') {
      if (
        this.optionGasValue &&
        this.uploadedDocumentFront &&
        this.uploadedDocumentBack
      ) {
        this.goNextStep = true;
      } else {
        this.goNextStep = false;
      }
    }
    if (
      this.typeRichiesta === 'Luce&Gas' &&
      this.uploadedDocumentFront &&
      this.uploadedDocumentBack
    ) {
      if (this.optionLightValue && this.optionGasValue) {
        this.goNextStep = true;
      } else {
        this.goNextStep = false;
      }
    }
  }

  getValidCheckboxes(value, type) {
    switch (type) {
      case 'gas':
        if (value === 'declare') {
          this.checkboxGasContainer.checkboxGasDeclare = false;
        }
        if (value === 'informative') {
          this.checkboxGasContainer.checkboxGasInformative = false;
        }
        break;

      case 'light':
        if (value === 'declare') {
          this.checkboxLightContainer.checkboxLightDeclare = false;
        }
        if (value === 'informative') {
          this.checkboxLightContainer.checkboxLightInformative = false;
        }
    }
  }

  fileOverBase(event, type) {
    switch (type) {
      case 'front':
        this.overDropFront = event;
        break;
      case 'back':
        this.overDropBack = event;
    }
  }

  private scrollOnInvalidElement(element) {
    document.getElementById(element).scrollIntoView({
      behavior: 'smooth',
      inline: 'nearest',
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/alg-linear-consent-request/alg-linear-consent-request.ts